/**
 * Shared pacing for the campaign carousels — the home hero and the dashboard
 * promo, so the two cannot drift apart.
 *
 * antd's defaults (3s on screen, a 0.5s linear slide) read as a ticker: a banner
 * moves on before it has been taken in, and a constant-speed slide has no settle
 * to it. 8s of dwell with a 1.2s eased transition gives each poster time to be
 * read and lands softly.
 */
export const CAROUSEL_PACING = {
    autoplaySpeed: 8000,
    speed: 1200,
    // Both names on purpose. The slide is a CSS transition and only `cssEase`
    // reaches it; antd's documented `easing` drives react-slick's JS fallback for
    // when CSS transitions are off. Setting `easing` alone leaves the curve at
    // its default — verified in the browser, where the track's transition
    // serialised with no timing function at all.
    cssEase: 'ease-in-out',
    easing: 'ease-in-out',
    // A visitor reading a banner should not have it pulled away mid-sentence.
    pauseOnHover: true,
    pauseOnDotsHover: true,
};
